import React from 'react';

const FormError = (props) => {
        return (
            <span style={props.style ? props.style : {margin: 0}} className='has-error-message help-block'>
                 <span> </span>{props.errorText}
            </span>);
};

export default FormError;